/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13 13a1 1 0 01-2 0V8a1 1 0 012 0v5zm-1 4a1 1 0 110-2 1 1 0 010 2zm0-15C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" _fill="#566473"/>'
  }
})
